import { useEffect } from "react";
import Alert from "react-bootstrap/esm/Alert";
import Button from "react-bootstrap/esm/Button";
import Container from "react-bootstrap/esm/Container";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faScrewdriverWrench } from "@fortawesome/free-solid-svg-icons";

const TALLY_FORM_ID = "68X8Je";
const TALLY_WIDGET_SRC = "https://tally.so/widgets/embed.js";

declare global {
    interface Window {
        Tally?: {
            openPopup: (formId: string, options?: object) => void;
        };
    }
}

/** Adds the Tally widget script to the page once. */
function loadTallyScript() {
    if (
        window.Tally ||
        document.querySelector(`script[src="${TALLY_WIDGET_SRC}"]`)
    ) {
        return;
    }
    const s = document.createElement("script");
    s.src = TALLY_WIDGET_SRC;
    s.async = true;
    document.body.appendChild(s);
}

function openWaitlistPopup() {
    if (window.Tally) {
        window.Tally.openPopup(TALLY_FORM_ID, {
            layout: "modal",
            width: 700,
            hideTitle: true
        });
    } else {
        // Script is still loading or was blocked. Open the hosted form instead.
        window.open(`https://tally.so/r/${TALLY_FORM_ID}`, "_blank");
    }
}

/** Friendly maintenance icon shown above the notice. */
export function MaintenanceIcon() {
    return (
        <div className="mb-3" aria-hidden="true">
            <FontAwesomeIcon
                icon={faScrewdriverWrench}
                size="3x"
                className="text-warning-emphasis"
                style={{ transform: "rotate(-10deg)" }}
            />
        </div>
    );
}

/** Button that opens the Tally waitlist form as a pop-up. */
export function WaitlistButton(props: { className?: string }) {
    useEffect(loadTallyScript, []);

    return (
        <Button
            className={props.className}
            onClick={openWaitlistPopup}
        >
            Join the Waitlist
        </Button>
    );
}

/** Notice and waitlist button. Every search entry point renders this page. */
export default function Maintenance() {
    return (
        <>
            <Helmet>
                <title>Next Jobs | Under Maintenance</title>
            </Helmet>
            <Container
                className="py-5 text-center"
                style={{ marginTop: "56px", maxWidth: "720px" }}
            >
                <Alert variant="warning" className="shadow py-4">
                    <MaintenanceIcon />
                    <Alert.Heading>Job search is under maintenance</Alert.Heading>
                    Job search is unavailable for the moment. Join the waitlist
                    and we will tell you when search is back.
                </Alert>
                <WaitlistButton />
            </Container>
        </>
    );
}
